var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandbag3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17874 6.81333H4.03012C2.85202 6.81333 1.92133 7.81122 2.00526 8.98439L2.08828 10.1447C2.15718 10.1674 2.22398 10.2004 2.28648 10.2441L7.78 14.0832C10.3138 15.8539 13.6862 15.8539 16.22 14.0832L21.7135 10.2441C21.776 10.2004 21.8428 10.1674 21.9117 10.1447L21.9947 8.98439C22.0787 7.81122 21.148 6.81333 19.9699 6.81333H16.8213C16.8213 4.155 14.6627 2 12 2C9.3373 2 7.17874 4.155 7.17874 6.81333ZM8.70125 6.81333C8.70125 4.99448 10.1782 3.52 12 3.52C13.8219 3.52 15.2988 4.99448 15.2988 6.81333H8.70125ZM14.03 11.88C14.03 12.9993 13.1211 13.9067 12 13.9067C10.8789 13.9067 9.96999 12.9993 9.96999 11.88C9.96999 10.7607 10.8789 9.85333 12 9.85333C13.1211 9.85333 14.03 10.7607 14.03 11.88Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75516 21C3.69014 21 2.80619 20.1783 2.73031 19.1177L2.2251 12.0565L6.90694 15.3284C9.96495 17.4655 14.0351 17.4655 17.0931 15.3284L21.7749 12.0565L21.2697 19.1177C21.1939 20.1783 20.3099 21 19.2449 21H4.75516Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbag3);
export default __webpack_public_path__ + "static/media/handbag-3.2c1386dc31889f9eefbd720a56224861.svg";
export { ForwardRef as ReactComponent };